import { type Conversation } from '@twilio/conversations';

export interface ConversationsClientProxy extends Conversation { };

// export interface IChat {
//     id: string; // coversation sid
//     messages: Array<IChatMessage>;
//     participants: Array<any>;
//     // audioId: string;
//     // videoId: string;
// }

export type IChatAuth = {
    token: string;
    expiry: number;
}

export type Participant = any;

export type JoinChatResponse = {
    auth: IChatAuth,
    identity: string,
    chatId: string
};
export interface IChatMessage {
    body: string;
    author: string;
    type?: string;
    json?: any;
}


export type ConnectionState = 'connecting' | 'connected' | 'disconnecting' | 'disconnected' | 'denied';

export interface ChatConvo extends Conversation { }